function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from "../../../styleguide";
import { IconLogin } from "../../Icon";
import { TabBarNotification } from "./Notification";
import Label from "./Label";
import ToolTip from "../ToolTip";
import StyledLink from "./StyledLink";
var Wrapper = styled.div.withConfig({
  displayName: "Profile__Wrapper",
  componentId: "sc-exqh0k-0"
})(["position:relative;"]);

var Profile = function Profile(_ref) {
  var pathname = _ref.pathname,
      userInfo = _ref.userInfo,
      onLoginClick = _ref.onLoginClick,
      tooltipInfo = _ref.tooltipInfo,
      tooltipCloseAction = _ref.tooltipCloseAction;
  var isActive = pathname === '/mitt-blocket' && userInfo.loggedIn;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovering = _useState2[0],
      setIsHovering = _useState2[1];

  var userDisplayName = userInfo && userInfo.displayNames && userInfo.displayNames.spid || 'Mitt Blocket'; // triggers when user's not logged in

  var onProfileLinkClick = function onProfileLinkClick(e) {
    e.preventDefault();
    onLoginClick(e);
  };

  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(StyledLink, {
    href: "/mitt-blocket",
    onMouseOver: function onMouseOver() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    },
    onClick: !userInfo.loggedIn ? onProfileLinkClick : null
  }, /*#__PURE__*/React.createElement(TabBarNotification, null, isActive ? /*#__PURE__*/React.createElement(IconLogin, {
    width: 20,
    height: 20,
    color: colors.red500
  }) : /*#__PURE__*/React.createElement(IconLogin, {
    width: 20,
    height: 20,
    color: isHovering ? colors.grey800 : colors.grey700
  })), /*#__PURE__*/React.createElement(Label, {
    isActive: isActive,
    isHovering: isHovering,
    "data-hj-suppress": userInfo.loggedIn
  }, userInfo.loggedIn ? userDisplayName : 'Logga in')), tooltipInfo && /*#__PURE__*/React.createElement(ToolTip, {
    data: tooltipInfo,
    closeAction: tooltipCloseAction
  }));
};

Profile.propTypes = process.env.NODE_ENV !== "production" ? {
  pathname: PropTypes.string,
  userInfo: PropTypes.shape({
    loggedIn: PropTypes.bool,
    displayNames: PropTypes.shape({
      spid: PropTypes.string
    })
  }),
  onLoginClick: PropTypes.func,
  tooltipInfo: PropTypes.object,
  tooltipCloseAction: PropTypes.func
} : {};
export default Profile;
//# sourceMappingURL=Profile.js.map